export default "__VITE_ASSET__CTErM0JS__"